import {
	GiftCardAuthorizationRequest,
	GiftCardAuthorizationResponse,
	GiftCardInquiryRequest,
	GiftCardInquiryResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class GiftCard<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags GiftCard
	 * @name Inquiry
	 * @request POST:/store/{storeId}/hdm/payments/giftcard/inquiry
	 * @response `200` `GiftCardInquiryResponse` GiftCard inquiry completed successfully
	 * @response `400` `void` Invalid request
	 * @response `500` `void` Internal server error
	 */
	inquiry = (
		storeId: string,
		data: GiftCardInquiryRequest,
		query?: {
			/** @example "json" */
			responseFormat?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (loggerCan('trace') && (!this.http.traceDetails || this.http.traceDetails['inquiry'])) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/payments/giftcard/inquiry`,
				params: _params,
				query: query,
				body: data,
				methodName: 'inquiry',
			};
			logger.trace(traceData);
		}
		return this.http.request<GiftCardInquiryResponse, void>({
			path: `/store/${storeId}/hdm/payments/giftcard/inquiry`,
			method: 'POST',
			query: query,
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags GiftCard
	 * @name Authorization
	 * @request POST:/store/{storeId}/hdm/payments/giftcard/authorization
	 * @response `200` `GiftCardAuthorizationResponse` GiftCard authorization completed successfully
	 * @response `400` `void` Invalid request
	 * @response `500` `void` Internal server error
	 */
	authorization = (
		storeId: string,
		data: GiftCardAuthorizationRequest,
		query?: {
			/** @example "json" */
			responseFormat?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['authorization'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/payments/giftcard/authorization`,
				params: _params,
				query: query,
				body: data,
				methodName: 'authorization',
			};
			logger.trace(traceData);
		}
		return this.http.request<GiftCardAuthorizationResponse, void>({
			path: `/store/${storeId}/hdm/payments/giftcard/authorization`,
			method: 'POST',
			query: query,
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
